import queuePageReducers from "queue/reducers";
import cropPageReducers from "pages/crop/reducers";
import cameraTabReducers from "tabs/Camera/reducers";
import dropboxTabReducers from "tabs/Dropbox/reducers";
import facebookTabReducers from "tabs/Facebook/reducers";
import gDriveTabReducers from "tabs/GoogleDrive/reducers";
import imageSearchTabReducers from "tabs/ImageSearch/reducers";
import instagramTabReducers from "tabs/Instagram/reducers";
import iStockTabReducers from "tabs/iStock/reducers";
import unsplashTabReducers from "tabs/Unsplash/reducers";
import shutterstockTabReducers from "tabs/ShutterStock/reducers";
import widgetConfig from "./widgetConfig";
import uploadQueue from "./uploadQueue";
import widgetData from "./widgetData";
import widgetStyles from "./widgetStyles";

export default {
	widgetConfig,
	uploadQueue,
	widgetData,
	widgetStyles,
	...queuePageReducers,
	...cropPageReducers,
	...cameraTabReducers,
	...dropboxTabReducers,
	...facebookTabReducers,
	...gDriveTabReducers,
	...imageSearchTabReducers,
	...instagramTabReducers,
	...shutterstockTabReducers,
	...iStockTabReducers,
	...unsplashTabReducers,
};
